var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.9375C9.01035 1.9375 2.9375 8.01035 2.9375 15.5C2.9375 22.9896 9.01035 29.0625 16.5 29.0625C23.9896 29.0625 30.0625 22.9896 30.0625 15.5C30.0625 8.01035 23.9896 1.9375 16.5 1.9375ZM21.5072 20.6525L19.5092 20.6435L16.5 17.0561L13.4938 20.6404L11.4928 20.6495C11.3596 20.6495 11.2506 20.5436 11.2506 20.4073C11.2506 20.3498 11.2718 20.2953 11.3081 20.2499L15.2467 15.5575L11.3081 10.8682C11.2715 10.8238 11.2512 10.7682 11.2506 10.7107C11.2506 10.5775 11.3596 10.4686 11.4928 10.4686L13.4938 10.4776L16.5 14.065L19.5062 10.4807L21.5042 10.4716C21.6374 10.4716 21.7464 10.5775 21.7464 10.7138C21.7464 10.7713 21.7252 10.8258 21.6889 10.8712L17.7563 15.5605L21.6919 20.2529C21.7282 20.2983 21.7494 20.3528 21.7494 20.4104C21.7494 20.5436 21.6404 20.6525 21.5072 20.6525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fe1c72d1e4d1578d050609c6d940df95.svg";
export { ForwardRef as ReactComponent };